function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0045 13C9.87639 13.0003 9.74984 12.9768 9.63412 12.931C9.51841 12.8853 9.41646 12.8186 9.33577 12.7357L5.19502 8.45038C5.06893 8.32258 5 8.16228 5 7.99685C5 7.83142 5.06893 7.67112 5.19502 7.54332L9.48151 3.25801C9.62703 3.11216 9.83613 3.02043 10.0628 3.00302C10.2895 2.98561 10.5152 3.04393 10.6903 3.16516C10.8654 3.28639 10.9755 3.4606 10.9964 3.64946C11.0173 3.83832 10.9473 4.02636 10.8017 4.17221L6.96963 8.00042L10.6732 11.8286C10.778 11.9335 10.8446 12.0611 10.8651 12.1965C10.8855 12.3319 10.859 12.4693 10.7887 12.5925C10.7183 12.7158 10.6071 12.8196 10.4681 12.8918C10.3291 12.964 10.1682 13.0015 10.0045 13Z",
  fill: "#0E7EE4"
});

function SvgReturnIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnIcon);
export default __webpack_public_path__ + "static/media/ReturnIcon.55214e7b339452c00648cd9f226aeb0d.svg";
export { ForwardRef as ReactComponent };